import { render, staticRenderFns } from "./Sopyo.vue?vue&type=template&id=64efe261&scoped=true"
import script from "./Sopyo.vue?vue&type=script&lang=js"
export * from "./Sopyo.vue?vue&type=script&lang=js"
import style0 from "./Sopyo.vue?vue&type=style&index=0&id=64efe261&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64efe261",
  null
  
)

export default component.exports